const IMG = "/img/logos";

const LOGO_MAP = {
  "bsg-advisors": `${IMG}/bsg.white.png`,
  "keller-williams-realty": `${IMG}/kw.white.png`,
  "dlm-commercial": `${IMG}/dlm.white.png`,
  "fully-promoted": `${IMG}/fullypromoted.white.png`,
  "tsc-restoration": `${IMG}/tsc.white.png`,
  "iq-manufacturing": `${IMG}/iq.white.png`,
};

export default function CaseLogo({ slug, client, className = "" }) {
  const src = LOGO_MAP[slug];
  const initials = client
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  return (
    <div
      data-testid={`case-logo-${slug}`}
      className={`flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-900 shadow-sm ${className}`}
    >
      {src ? (
        <img
          src={src}
          alt={`${client} logo`}
          loading="lazy"
          className="max-h-9 max-w-[72%] object-contain [filter:brightness(0)_invert(1)]"
        />
      ) : (
        <span className="font-mono text-sm font-bold tracking-widest text-slate-300">
          {initials}
        </span>
      )}
    </div>
  );
}
